import { createSelector } from '@reduxjs/toolkit';
import { IState } from 'core';
import { SLOTS } from 'types';
import { IBetAvailabilityState } from './types';

export const betAvailabilityRootSelector = (state: IState) => state.betAvailabilityReducer;

export const availableBetsSelector = createSelector(
  betAvailabilityRootSelector,
  (state: IBetAvailabilityState): SLOTS[] => state.availableBets,
);
